import React, { useEffect, useState } from 'react';
import Button from '../../components/Button';
import ui from './ProductAdminDashboard.module.css';

// Number input with a Save button. Saves only a changed whole number of at least `min`.
export default function LimitEditor({ value, min = 0, onSave, label }) {
  const [draft, setDraft] = useState(value == null ? '' : String(value));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setDraft(value == null ? '' : String(value));
  }, [value]);

  const number = Number(draft);
  const valid = draft !== '' && Number.isInteger(number) && number >= min;
  const changed = valid && number !== Number(value);

  const save = async () => {
    if (!changed) return;
    setSaving(true);
    try {
      await onSave(number);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={ui.limitEditor}>
      <input
        type="number"
        min={min}
        step={1}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && save()}
        aria-label={label}
        title={min ? `At least ${min.toLocaleString('en-IN')}` : undefined}
        className={`${ui.limitInput} ${draft !== '' && !valid ? ui.limitInputError : ''}`}
      />
      <Button size="sm" onClick={save} loading={saving} disabled={!changed}>
        Save
      </Button>
    </div>
  );
}
